<h3 mat-dialog-title>เงื่อนไขการรับประกัน</h3>
<mat-dialog-content>
  <h4>นโยบายการรับประกันยางรถยนต์ 180 วัน เปลี่ยนฟรี</h4>
  <p>นโยบายการรับประกันยางชำรุด บาด บวม แตก 180 วัน เปลี่ยนฟรีสำหรับผลิตภัณฑ์ยางรถยนต์ Advance-PCR มีเงื่อนไขและข้อปฏิบัติดังนี้</p>
  <ol>
    <li>
      บริษัท ต.สยาม คอมเมอร์เชียล จํากัด จะรับประกันยางชำรุด 180 วัน เปลี่ยนฟรี สำหรับผลิตภัณฑ์ยางรถยนต์ภายใต้ยี่ห้อADVANCE
      เฉพาะที่บริษัทฯนําเข้ามาจากต่างประเทศ ตามข้อกําหนดและเงื่อนไขที่ได้ระบุไว้ในนโยบายการรับประกันนี้เท่านั้น
      โดยไม่รวมถึงการรับประกันอื่นใดนอกเหนือจากนี้ เช่น ค่าบริการอันเกิดขึ้นจากการถอดใส่ ค่าสูญเสียเวลา
      ค่าสูญเสียอันเนื่องจากการไม่ได้ใช้รถยนต์ ค่าความไม่สะดวกและผลจากการเสียหายอื่นตามที่กฎหมายอนุญาต
    </li>
    <li>
      บริษัท ต.สยาม คอมเมอร์เชียล จำกัด จะมอบสิทธิ์การรับประกันยางชำรุด 180 วัน เปลี่ยนฟรี นับตั้งแต่วันที่ระบุในใบเสร็จรับเงิน
      เมื่อเปลี่ยนยางรถยนต์ภายใต้ยี่ห้อADVANCE ทุกรุ่น ทุกขนาด จำนวนตั้งแต่ 2 เส้นขึ้นไป ต่อรถ 1 คัน ต่อ 1 ใบเสร็จรับเงิน
      ที่ตัวแทนจำหน่ายยางรถยนต์อย่างเป็นทางการของบริษัทฯ และต้องลงทะเบียนผ่านโปรแกรมที่บริษัทกำหนดภายใน 15
      วันนับแต่วันที่ระบุไว้ในใบเสร็จรับเงิน โดยข้อมูลถูกต้องและครบถ้วนตามความจริง และจะสิ้นสุดหรือหมดอายุการรับประกันภายหลัง 180
      วันนับตั้งแต่วันที่ระบุไว้ในใบเสร็จรับเงิน
    </li>
    <li>
      การรับประกันยางชำรุด 180 วันเปลี่ยนฟรี ครอบคลุมยางชำรุดทั้งที่เกิดจากการใช้งานตามปกติ
      หรือเกิดจากการผลิตที่ไม่สามารถปะซ่อมแซมให้สามารถใช้งานตามปกติได้ เช่น ยางถูกของมีคมบาดแก้มยาง
      ยางบวมจากการกระแทกหรือตกหลุมอย่างแรงหรือเบียดฟุตบาธ ยางปริแตก เป็นต้น แต่การรับประกันฯนี้ ไม่ครอบคลุมความเสียหายของกระทะล้อ
      ล้อแม็กซ์หรืออะไหล่เกี่ยวเนื่องอื่นๆ และไม่ครอบคลุมถึงอุบัติเหตุ ความเสียหาย ต่อชีวิตและทรัพย์สิน
      รวมถึงการบาดเจ็บของผู้ใช้สินค้าดังกล่าว
    </li>
    <li>
      ผลของการพิจารณาให้การชดเชยยางรถยนต์ที่ชำรุดเสียหาย ให้ถือเอาการพิจารณาของผู้แทนที่ได้รับการแต่งตั้งจาก Advance Tyre (Vietnam) Co.,Ltd
      เป็นที่สิ้นสุด และบริษัทฯขอสงวนสิทธิ์ในการเรียกเก็บเงินค่ายางรถยนต์ที่ได้ทำการชดเชยไปแล้วกลับคืน
    </li>
    <li>
      การขอรับการชดเชยยางรถยนต์ในการรับประกันนี้
      ผู้ขอรับประกันจะต้องนำยางที่ชำรุดเสียหายมาแสดงและส่งมอบต่อร้านค้าที่ซื้อยางเพื่อส่งคืนให้กับทางบริษัทฯ
      และต้องแนบใบเสร็จรับเงินพร้อมเอกสาร/หลักฐานการรับประกันฯ เพื่อการตรวจสอบข้อมูลยาง(ยี่ห้อ/รุ่น/ขนาด)
      และข้อมูลรถ(ยี่ห้อรถ/รุ่นรถ/ทะเบียนรถ) หากข้อมูลยางชำรุดและเอกสารหลักฐานตามที่ระบุข้างต้นในใบรับประกันไม่ถูกต้องตรงกัน
      หรือไม่สามารถตรวจสอบข้อมูลดังกล่าวได้ ทางบริษัทฯ ขอสงวนสิทธิ์ ในการยกเลิกการรับประกันฯ
    </li>
    <li>
      การเปลี่ยนยางเส้นใหม่เพื่อชดเชยยางที่ชำรุดโดยบริษัทฯ จะเปลี่ยนยางยี่ห้อ รุ่น และขนาดเดียวกันกับยางเดิมที่ชำรุด ยกเว้นกรณีไม่มียาง
      ยี่ห้อ รุ่นและขนาดเดิม ทางบริษัทฯ จะชดเชยยางยี่ห้อ หรือ รุ่นอื่นทดแทน และหากยางใหม่ที่ชดเชยมีราคาสูงกว่า
      ผู้ขอรับประกันจะต้องชำระเงินส่วนต่างที่เกิดขึ้น โดยคิดคำนวณจากราคา ณ วันที่เปลี่ยนยางใหม่ กรณียางชำรุดและมีการเปลี่ยนยางเส้นใหม่
      ระยะการรับประกัน 180 วัน ยังคงนับจากวันที่ในใบเสร็จรับเงินที่ลงทะเบียนกับบริษัทฯ
      โดยบริษัทฯจะเปลี่ยนยางเส้นใหม่เพื่อชดเชยยางที่ชำรุดให้สูงสุดตามจำนวนที่ระบุในใบเสร็จรับเงินที่ใช้ในการลงทะเบียน (โดยไม่เกิน 4 เส้นต่อ
      1 ใบเสร็จรับเงิน) ภายในระยะเวลาการรับประกันยางชำรุด 180 วัน
    </li>
    <li>การเปลี่ยนยางเส้นใหม่ ไม่รวมถึงค่าบริการถอดและใส่ล้อ รวมถึงค่าบริการตั้งศูนย์ถ่วงล้อ และเติมลมยาง ไนโตรเจน</li>
    <li>
      ยางชํารุดที่ได้รับการรับการพิจารณาชดเชย จะตกเป็นกรรมสิทธิ์ของ บริษัท ต.สยาม คอมเมอร์เชียล จํากัด และ
      ผู้ขอรับประกันจะไม่สามารถเรียกร้องขอรับคืนได้
    </li>
    <li>
      การรับประกันนี้ ไม่ครอบคลุมในกรณี ดังนี้
      <ol>
        <li>ยางที่ถูกของมีคมบาด ตำและสามารถปะซ่อมเพื่อใช้งานได้ตามปกติ โดยผู้ใช้จะต้องเป็นผู้รับผิดชอบ ค่าใช้จ่ายในการปะซ่อมแซม</li>
        <li>ความไม่พึงพอใจในสินค้า เช่น เสียงของยาง ความแข็งกระด้างหรือนุ่มนวลของยาง</li>
        <li>ขนาดยาง รุ่นยาง ไม่ตรงกับการใช้งาน หรือ ไม่เหมาะสมกับตัวรถ</li>
        <li>การใช้งานของยางที่ผิดประเภท ใช้เพื่อการแข่งขัน ยางที่ถูกซุ้มล้อบาด ยางชำรุดเนื่องจากการถอด ใส่ หรือการประกอบกระทะล้อ</li>
        <li>
          ผู้ซื้อไม่ได้ลงทะเบียนรับสิทธิประโยชน์การรับประกันยางรถยนต์ชำรุด 180 วัน เปลี่ยนฟรี
          รวมถึงกรณีเอกสารหลักฐานการรับประกันชำรุดหรือสูญหาย
        </li>
        <li>มีการเปลี่ยนแปลงกรรมสิทธิ์หรือเปลี่ยนการครอบครองจากผู้ซื้อรายเดิม</li>
      </ol>
    </li>

    <li>
      กรณียางชำรุดและผู้ขอรับประกันได้เปลี่ยนยางเส้นใหม่และส่งมอบยางชำรุดให้กับร้านค้าแล้ว ร้านค้าจะต้องนำส่งยางที่ชำรุดมาให้ บริษัท ต.สยาม
      คอมเมอร์เชียล จำกัด พิจารณาตรวจสอบและชดเชยยางเส้นใหม่ให้กับร้านค้า ตามเงื่อนไขที่ได้กำหนดไว้ในนโยบายการรับประกันนี้
      โดยผู้ขอรับประกันเป็นผู้รับภาระค่าขนส่ง และทางบริษัทฯ จะไม่รับผิดชอบต่อการสูญหาย หรือความเสียหายใดๆ ในระหว่างการขนส่ง
    </li>
    <li>
      บริษัทฯ ขอสงวนสิทธิ์ไม่ทำการเปลี่ยนยางเส้นใหม่ให้ ในกรณีที่ทางบริษัทฯ ได้ตรวจสอบยางที่ชำรุด ดังกล่าวและพบว่า
      การชำรุดของยางที่ขอรับประกันเกิดจากความตั้งใจหรือจงใจจากผู้ใช้งานหรือตัวแทนจำหน่าย ให้เกิดความเสียหายดังกล่าว
    </li>
    <li>
      ผู้ขอรับประกัน จะต้องลงทะเบียนการรับประกันตามที่บริษัทฯกำหนดโดยระบุข้อมูลให้ครบถ้วนและถูกต้องตาม ความเป็นจริง
      มิฉะนั้นการรับประกันจะเป็นโมฆะและไม่มีผลบังคับใช้
    </li>
    <li>
      ทางบริษัทฯ จะดำเนินการตามกฎหมายหากทำการตรวจสอบและพบว่าผู้ขอการรับประกัน และ/หรือร้านค้า และ/หรือ ตัวแทนจำหน่าย
      ได้ทำการทุจริตเพื่อให้ทางบริษัทฯ เกิดความเสียหายจากนโยบายการรับประกันดังกล่าวนี้
    </li>
    <li>
      บริษัท ต.สยาม คอมเมอร์เชียล จํากัด ขอสงวนสิทธิ์ในการยกเลิก และ/หรือ แก้ไขเปลี่ยนแปลงนโยบายการรับประกันฯนี้ ทั้งหมดหรือส่วนหนึ่งส่วนใด
      เพื่อความเหมาะสม โดยไม่จําเป็นต้องแจ้งให้ทราบล่วงหน้า
    </li>
  </ol>

  <h4>นโยบายการรับประกันคุณภาพยางรถยนต์ Advance-PCR</h4>
  <p>นโยบายการรับประกันคุณภาพฯ สำหรับผลิตภัณฑ์ยางรถยนต์ Advance-PCR มีเงื่อนไขและข้อปฏิบัติดังนี้</p>
  <ol>
    <li>
      บริษัท ต.สยาม คอมเมอร์เชียล จํากัด จะรับประกันคุณภาพผลิตภัณฑ์ยางรถยนต์ภายใต้ยี่ห้อ ADVANCE เฉพาะที่บริษัทฯนําเข้ามาจากต่างประเทศ
      ตามข้อกําหนดและเงื่อนไขที่ได้ระบุไว้ในนโยบายการรับประกันคุณภาพนี้เท่านั้น โดยไม่รวมถึงการรับประกันอื่นใดนอกเหนือจากนี้ เช่น
      ค่าบริการอันเกิดขึ้นจากการถอด ใส่ ค่าสูญเสียเวลา ค่าสูญเสียอันเนืองจากการไม่ได้ใช้รถยนต์
      ค่าความไม่สะดวกและผลจากการเสียหายอื่นตามที่กฎหมายอนุญาต
    </li>
    <li>
      ผลิตภัณฑ์ยางรถยนต์ทุกเส้น จะได้รับการพิจารณาชดเชยต่อเมื่อได้รับการตรวจสอบเป็นที่แน่ชัดว่ายางชํารุดดังกล่าวมีสาเหตุจากผู้ผลิต
      เช่นเกิดจากข้อบกพร่องในการออกแบบ กรรมวิธีการผลิต และ/หรือ วัสดุที่ใช้ในการผลิตเป็นต้น
    </li>
    <li>
      การประเมินความชำรุดเสียหายของยางรถยนต์ว่าเกิดขึ้นเนื่องจากผู้ใช้หรือผู้ผลิต
      การตัดสินขั้นสุดท้ายจะกระทําโดยบุคคลที่ได้รับการแต่งตั้งจาก Advance Tyre (Vietnam) Co., Ltd
    </li>
    <li>
      การชดเชย โดยบริษัทฯจะชดเชยยางยางเส้นใหม่ที่เป็นยางยี่ห้อ รุ่น และขนาดเดียวกันกับยางเดิมที่ชำรุด
      หากตรวจสอบได้ว่าการชำรุดเกิดจากคุณภาพผลิตภัณฑ์
      <span>และความลึกร่องดอกยางที่เหลืออยู่มีค่ามากกว่า 2.5 มม.</span>
      <br />
      <span style="text-decoration: underline">หมายเหตุ</span>
      กรณีไม่มียางยี่ห้อ รุ่นและขนาดเดิม ทางบริษัทฯ จะชดเชยยางยี่ห้อ หรือ รุ่นอื่นทดแทน และหากยางใหม่ที่ชดเชยมีราคาสูงกว่า
      ผู้ขอรับประกันจะต้องชำระเงินส่วนต่างที่เกิดขึ้น โดยคิดคำนวณจากราคา ณ วันที่เปลี่ยนยาง
    </li>
    <li>ยางชํารุดที่ได้รับการพิจารณาให้การชดเชย ให้ตกเป็นกรรมสิทธิ์ของ บริษัท ต.สยาม คอมเมอร์เชียล จํากัด</li>
    <li>
      ระยะเวลาการรับประกันคุณภาพผลิตภัณฑ์ฯ: 5 ปีนับแต่วัน เดือน ปี ที่ซื้อยาง โดยผู้ขอรับประกันจะต้องลงทะเบียนการรับประกันตามที่บริษัทฯกำหนด
      <span>ภายใน 15 วันนับแต่วันที่ระบุไว้ในใบเสร็จรับเงิน</span>
      โดยระบุข้อมูลให้ครบถ้วนและถูกต้องตามความเป็นจริง มิฉะนั้นการรับประกันจะเป็นโมฆะและไม่มีผลบังคับใช้
    </li>
    <li>
      ยางรถยนต์ที่มีลักษณะดังต่อไปนี้ จะไม่ได้รับการพิจารณาชดเชยและให้ถือว่าสิ้นสุดการรับประกัน ได้แก่
      <ol>
        <li>
          ยางชำรุดที่เกิดจากการถูกของแหลมคมบาดและ/หรือตํา เช่น ตะปู แผ่นเหล็ก เศษแก้ว หรือยางชำรุดที่เกิดจากการกระแทกกับก้อนหิน ขอบถนน
          ขอบหลุม หรือวัตถุอื่นๆ
        </li>
        <li>ยางชำรุดที่เกิดจากการใช้ลมยางไม่ถูกต้อง หรือใช้กระทะล้อไม่ถูกต้อง หรือเกิดจากการใช้งานในขณะที่ไม่มี แรงดันลมยาง</li>
        <li>
          ยางสึกหรอผิดปกติ เนื่องจากการใช้แรงดันลมยางไม่ถูกต้อง ไม่มีการสลับตำแหน่งยาง การใช้กระทะล้อไม่ถูกต้อง ความบกพร่องของช่วงล่าง
          ศูนย์ล้อ โช้คอัพ ระบบเบรค รวมถึงการไม่สมดุลของล้อหรือความบกพร่องของชิ้นส่วนอื่นๆของรถยนต์
        </li>
        <li>ยางชำรุดเนื่องจาก การใส่ การถอดหรือการประกอบยางกับกระทะล้อไม่ถูกต้อง</li>
        <li>ยางที่เกิดปัญหาเต้นสั่น ภายหลังจากดอกยางสึกหรอไปแล้วมากกว่า 1มม.</li>
        <li>ยางที่ไม่ได้ซื้อขายผ่านผู้จัดจําหน่ายอย่างเป็นทางการจาก Advance Tyre (Vietnam) Co., Ltd</li>
        <li>ยางที่ถูกนำไปใช้ ไม่ถูกต้องตามข้อกําหนด หรือใช้ในการแข่งขัน หรือรถที่ใช้งานพิเศษ</li>
        <li>ยางที่ถูกใช้งานจนความลึกของร่องดอกยางหลัก (Principal grooves) เหลือน้อยกว่า 2.5 มิลลิเมตร</li>
        <li>ยางที่มีการชำรุดเสียหายสืบเนืองมาจากการปะ – ซ่อม</li>
        <li>ยางที่เกิดอาการเสียงยางผิดปกติ อันเนื่องมาจากการสึกหรอผิดปกติของดอกยางหรือเสียงยางอัน เนื่องมาจากความไม่พึงพอใจของลูกค้า</li>
        <li>
          ยางรถยนต์ภายใต้ยี่ห้อADVANCE ที่เป็นยางติดรถใหม่ (Original Equipment) และ/ หรือ เป็นยางนำเข้ามา
          <br />
          จากต่างประเทศโดยผู้นำเข้ารายอื่นๆที่มิใช่บริษัท ต.สยาม คอมเมอร์เชียล จำกัด จะไม่ได้รับการรับประกันฯ
          <br />
          ตามนโยบายฉบับนี้
        </li>
        <li>ยางที่ไม่ได้ลงทะเบียนรับสิทธิประโยชน์การรับประกันยางรถยนต์ชำรุด รวมถึงกรณีเอกสารหลักฐานการรับประกันชำรุดหรือสูญหาย</li>
        <li>ความไม่พึงพอใจในสินค้า เช่น เสียงของยาง ความแข็งกระด้างหรือนุ่มนวลของยาง</li>
        <li>ยางที่ถูกดัดแปลงแก้ไขหมายเลขยาง (Tire DOT serial or Tire Serial Number)</li>
      </ol>
    </li>
    <li>
      ร้านค้าหรือลูกค้า จะเป็นผู้ออกค่าใช้จ่ายในการขนส่งยางจากร้านค้ามายังบริษัทฯเพื่อขอให้บริษัทฯพิจารณาชดเชย
      โดยบริษัทฯจะไม่รับผิดชอบต่อการสูญหาย หรือความเสียหายใดๆในระหว่างการขนส่ง
    </li>
    <li>ร้านค้าหรือลูกค้า จะเป็นผู้ออกค่าใช้จ่ายในการขนส่งยางที่ไม่ได้รับการพิจารณาชดเชยกลับคืนให้ลูกค้า</li>
    <li>
      ทางบริษัทฯ จะดำเนินการตามกฎหมายหากทำการตรวจสอบและพบว่าผู้ขอการรับประกัน และ/หรือร้านค้า และ/หรือ ตัวแทนจำหน่าย
      ได้ทำการทุจริตเพื่อให้ทางบริษัทฯ เกิดความเสียหายจากนโยบายการรับประกันดังกล่าว
    </li>
    <li>
      บริษัท ต.สยาม คอมเมอร์เชียล จํากัด ขอสงวนสิทธิ์ในการยกเลิก และ/หรือ แก้ไขเปลี่ยนแปลงนโยบายการรับประกันคุณภาพฯนี้
      ทั้งหมดหรือส่วนหนึ่งส่วนใด เพื่อความเหมาะสม โดยไม่จําเป็นต้องแจ้งให้ทราบล่วงหน้า
    </li>
  </ol>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close>ปิด</button>
</mat-dialog-actions>
